import {IdPrefix, ParseErrorType} from '../idHelpers.enums';
import {ParseResult} from '../idHelpers.types';
import {allIdPrefixes} from '../idHelpers.consts';

export default function parseId(
  rawValue: string,
  expectedPrefixType: IdPrefix | IdPrefix[],
): ParseResult {
  const expectedPrefixes = Array.isArray(expectedPrefixType)
    ? expectedPrefixType
    : [expectedPrefixType];
  const normalized = rawValue.trim();

  if (!normalized) {
    return _invalidIdError(rawValue, expectedPrefixes);
  }

  const upperNormalized = normalized.toUpperCase();

  for (const prefix of expectedPrefixes) {
    if (upperNormalized.startsWith(prefix)) {
      const remainder = normalized.slice(prefix.length);
      const numericPart = Number(remainder);

      return Number.isInteger(numericPart) && numericPart >= 0
        ? _okResult(numericPart)
        : _invalidIdError(rawValue, expectedPrefixes);
    }
  }

  for (const prefix of allIdPrefixes) {
    if (!expectedPrefixes.includes(prefix) && upperNormalized.startsWith(prefix)) {
      return _wrongPrefixError(rawValue, prefix, expectedPrefixes);
    }
  }

  const parsed = Number(normalized);

  return Number.isInteger(parsed) && parsed >= 0
    ? _okResult(parsed)
    : _invalidIdError(rawValue, expectedPrefixes);
}

function _okResult(numericId: number): ParseResult {
  return {ok: true, numericId};
}

function _wrongPrefixError(
  rawValue: string,
  detectedPrefix: IdPrefix,
  expectedPrefix: IdPrefix[],
): ParseResult {
  return {
    ok: false,
    error: {
      errorType: ParseErrorType.WrongPrefix,
      rawValue,
      detectedPrefix,
      expectedPrefix,
    },
  };
}

function _invalidIdError(rawValue: string, expectedPrefixType: IdPrefix[]): ParseResult {
  return {
    ok: false,
    error: {
      errorType: ParseErrorType.InvalidId,
      rawValue,
      expectedPrefix: expectedPrefixType,
    },
  };
}
